import React, { useState } from "react";
import { Form, Card, Typography } from "antd";
import "./RegisterSecond.scss";
import InputGroup from "../../../components/InputGroup";
import MainButton from "../../../components/MainButton";
import CheckboxGroup from "../../../components/CheckboxGroup";
import city from "../../../assets/region.json";
import {
  optionalRegisterDataSecond,
  optionalRegisterDataThird,
  optionalRegisterCheckboxFirst,
  optionalRegisterCheckboxSecond,
  getOptionRegisterDataFirst,
} from "../config";
import mapCheckboxValue from "../../../components/CheckboxGroup/mapChecvkboxValue";
import {
  verifyMobile,
  checkEmail,
} from "../../../api/apiStore/Register/Register";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../../components/ConfirmModal";
import register2 from "../../../assets/img/img_register_step_02_n@2x.png";
import Loading from "../../../components/Loading/Loading.jsx";
import { useEffect } from "react/cjs/react.development";

const { Title } = Typography;

export default function RegisterSecond({ sendValue }) {
  let navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState({
    title: "提示",
    visible: false,
  });
  const [confirmModalMsg, setConfirmModalMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  let chekboxGroupValue = {
    gettingDiscountWay: [
      { value: "M", checked: true },
      { value: "S", checked: true },
      { value: "E", checked: true },
    ],
    interestActivities: [
      { value: "A", checked: false },
      { value: "B", checked: false },
      { value: "D", checked: false },
      { value: "C", checked: false },
      { value: "E", checked: false },
      { value: "F", checked: false },
      { value: "G", checked: false },
      { value: "H", checked: false },
      { value: "I", checked: false },
    ],
  };
  const getFormInitialValue = () => {
    const initialValue = JSON.parse(sessionStorage.getItem("register2"));
    return initialValue;
  };

  const checkboxValueHandler = () => {
    return mapCheckboxValue(chekboxGroupValue);
  };

  const onFinish = async () => {
    form
      .validateFields()
      .then(async (values) => {
        sendValue({ ...values, ...checkboxValueHandler() });
        setIsLoading(true);
        const verifyResp = await verifyMobile();
        setIsLoading(false);
        if (verifyResp.result.Code === "0") {
          navigate("/registerFinal");
        } else {
          setConfirmModal(() => {
            return { title: "提示", visible: true };
          });
          setConfirmModalMsg(verifyResp.result.Message);
        }
        return;
      })
      .catch((error) => {
        const { errorFields } = error;
        const filterErrorMsg = errorFields.map((item) => {
          const { errors } = item;
          item.errors = [...new Set(errors)];
          return item;
        });
      });
  };

  const handleOk = () => {
    setConfirmModal({ title: "提示", visible: false });
  };

  const onSubmit = (data) => {
    // chekboxValue = data;
    // if(data.length===3){
    //   chekboxGroupValue.gettingDiscountWay = data
    // }
    switch (data.length) {
      case 3:
        chekboxGroupValue = { ...chekboxGroupValue, gettingDiscountWay: data };
      case 9:
        chekboxGroupValue = { ...chekboxGroupValue, interestActivities: data };
    }
  };

  return (
    <div className="site-card-border-less-wrapper">
      <Loading isLoadingVisible={isLoading}></Loading>
      <Card bordered={false}>
        <img style={{ width: "100%", height: "100%" }} src={register2} />
        <Title className="register-title" level={5}>
          選填資料
        </Title>
        <Form form={form} name="register" initialValues={getFormInitialValue()}>
          <InputGroup
            inputAry={getOptionRegisterDataFirst(city)}
            className="group-wrapper-upper"
          ></InputGroup>
          <InputGroup inputAry={optionalRegisterDataSecond}></InputGroup>
          <InputGroup inputAry={optionalRegisterDataThird}></InputGroup>
          <CheckboxGroup
            checkboxData={optionalRegisterCheckboxFirst}
            onSubmit={onSubmit}
          ></CheckboxGroup>
          <CheckboxGroup
            checkboxData={optionalRegisterCheckboxSecond}
            onSubmit={onSubmit}
          ></CheckboxGroup>
          <p className="text-info">略過此步驟，直接註冊</p>
          <MainButton buttonType="main" onClick={onFinish}>
            下一步
          </MainButton>
        </Form>
      </Card>
      {confirmModal.visible ? (
        <ConfirmModal
          title={confirmModal.title}
          setModalvisible={confirmModal.visible}
          setHandleOk={handleOk}
          msg={confirmModalMsg}
        />
      ) : null}
      {/* <Loading isLoadingVisible={isLoading}></Loading> */}
    </div>
  );
}
